import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.find";
import "core-js/modules/es.array.find-index";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.join";
import "core-js/modules/es.array.map";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.number.to-fixed";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { tabulation, gmTool } from "@/mixins/index";
import channelComMixins from "./mixins/channelComMixins";
import { totalSummaryCk, totalSummaryCkCurrency } from "@/api/dataPirate/channelData";
import * as echarts from "echarts";
export default {
  mixins: [tabulation, channelComMixins, gmTool],
  name: "channel",
  data: function data() {
    return {
      searchData: {
        summary_flag: "w"
      },
      segmentSelection: [{
        label: this.$t('naturalWeek'),
        value: "w"
      }, {
        label: this.$t('naturalMonth'),
        value: "m"
      }, {
        label: this.$t('naturalQuarter'),
        value: "q"
      }, {
        label: this.$t('naturalYear'),
        value: "y"
      }],
      name: 'channel',
      activeChartChannel: '',
      chartDataMap: {}
    };
  },
  created: function created() {},
  mounted: function mounted() {},
  methods: {
    getDate: function getDate() {
      var now = new Date(this.$times.zeroTimeZone());
      var year = now.getFullYear();
      var month = (now.getMonth() + 1).toString().length < 2 ? "0" + (now.getMonth() + 1) : now.getMonth() + 1;
      var date = now.getDate().toString().length < 2 ? "0" + now.getDate() : now.getDate();
      var date = year + "-" + month + "-" + date;
      this.searchData.date = date;
    },

    /**
     * 渠道年季月周 star
     */
    searchClick: function searchClick() {
      var _arguments = arguments,
          _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var isverification, reqFn;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                isverification = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : false;
                // if(this.currencyClose && !this.searchData.currency_info){
                //   if(isverification){
                //     this.$message.error('请选择货币类型')
                //   }
                //   return
                // }
                _this.reqLoading = true;
                reqFn = _this.currencyClose ? totalSummaryCkCurrency : totalSummaryCk;
                _context.next = 5;
                return _this.getexchangeRate();

              case 5:
                if (_this.queryCurrency == 'VND') {
                  _this.screenList = _this.screenListVND;
                } else if (_this.queryCurrency == 'USD') {
                  _this.screenList = _this.screenListP;
                } else {
                  _this.screenList = _this.screenListP;
                }

                _this.tableDataList = _this.screenList;
                _this.screen = _this.screenList.map(function (i) {
                  return i.prop;
                });
                reqFn(_objectSpread(_objectSpread({}, _this.searchData), _this.defaultData())).then(function (res) {
                  if (res.code == 200) {
                    var _this$segmentSelectio;

                    _this.tableData = [];
                    _this.chartDataMap = {};
                    var rawData = res.data || {};
                    var channelKeys = Object.keys(rawData);
                    var currentLabel = ((_this$segmentSelectio = _this.segmentSelection.find(function (i) {
                      return i.value == _this.searchData.summary_flag;
                    })) === null || _this$segmentSelectio === void 0 ? void 0 : _this$segmentSelectio.label) || '';
                    var summaryData = null;
                    channelKeys.forEach(function (chKey) {
                      var _this$channelList;

                      if (chKey === '汇总') {
                        var _item = _objectSpread({}, rawData[chKey]);

                        _item['register_recharge_device_amountexchange'] = Number(_item['register_recharge_device_amount'] || 0) * _this.exchangeRate;
                        _item['register_recharge_account_amountexchange'] = Number(_item['register_recharge_account_amount'] || 0) * _this.exchangeRate;
                        _item['account_recharge_amountexchange'] = Number(_item['account_recharge_amount'] || 0) * _this.exchangeRate;

                        _this.processingListTow.forEach(function (pItem) {
                          _item[pItem] = _this.isyjfmvnd() ? Number(_item[pItem]) * 100 : _item[pItem];
                        });

                        _this.processingList.forEach(function (pItem) {
                          _item[pItem] = _this.$utils.conversion(_item[pItem]).toFixed(2);
                        });

                        summaryData = _objectSpread({
                          channel_mark: _item.channel_mark || _this.$t('summaryLabel'),
                          channel_name: _item.channel_name || _this.$t('summaryLabel'),
                          hours: currentLabel
                        }, _item);
                        return; // 跳过常规渠道循环
                      } // 直接读取对应渠道的数据对象


                      var item = _objectSpread({}, rawData[chKey]); // 查找兜底渠道名称


                      var matchedChannel = (_this$channelList = _this.channelList) === null || _this$channelList === void 0 ? void 0 : _this$channelList.find(function (c) {
                        return c.channel_mark == chKey;
                      });
                      var chName = item.channel_name || (matchedChannel === null || matchedChannel === void 0 ? void 0 : matchedChannel.channel_name) || chKey; // 2. 生成汇率换算字段

                      item['register_recharge_device_amountexchange'] = Number(item['register_recharge_device_amount'] || 0) * _this.exchangeRate;
                      item['register_recharge_account_amountexchange'] = Number(item['register_recharge_account_amount'] || 0) * _this.exchangeRate;
                      item['account_recharge_amountexchange'] = Number(item['account_recharge_amount'] || 0) * _this.exchangeRate;

                      _this.processingListTow.forEach(function (pItem) {
                        item[pItem] = _this.isyjfmvnd() ? Number(item[pItem]) * 100 : item[pItem];
                      });

                      _this.processingList.forEach(function (pItem) {
                        item[pItem] = _this.$utils.conversion(item[pItem]).toFixed(2);
                      }); // 构建表格行数据


                      var rowData = _objectSpread({
                        channel_mark: item.channel_mark || chKey,
                        channel_name: chName,
                        hours: currentLabel
                      }, item);

                      _this.tableData.push(rowData); // 存储给图表使用


                      _this.chartDataMap[chKey] = [rowData];
                    });

                    if (summaryData) {
                      _this.tableData.push(summaryData);
                    } // 默认选中下拉选项中的第一个渠道


                    if (_this.searchData.channel_list && _this.searchData.channel_list.length > 0) {
                      _this.activeChartChannel = _this.searchData.channel_list[0];
                    } else {
                      // 2. 顶部没有选中时，默认选中后端接口/数据返回的第一条渠道
                      var _channelKeys = Object.keys(rawData).filter(function (k) {
                        return k !== '汇总';
                      });

                      if (_channelKeys.length > 0) {
                        _this.activeChartChannel = _channelKeys[0];
                      } else if (_this.channelList.length > 0) {
                        _this.activeChartChannel = _this.channelList[0].channel_mark;
                      } else {
                        _this.activeChartChannel = '';
                      }
                    }

                    _this.getechannelChart();
                  }
                }).finally(function () {
                  _this.reqLoading = false;
                });

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    handleChartChannelChange: function handleChartChannelChange() {
      this.getechannelChart();
    },
    getechannelChart: function getechannelChart() {
      var _this$segmentSelectio2,
          _this2 = this;

      var chartDom = document.getElementById("echartchannel");

      if (this.echartchannel != null && this.echartchannel != "" && this.echartchannel != undefined) {
        this.echartchannel.dispose(); //销毁
      }

      this.echartchannel = echarts.init(chartDom);
      var currentChartData = this.chartDataMap[this.activeChartChannel] || [];
      var currentLabel = ((_this$segmentSelectio2 = this.segmentSelection.find(function (i) {
        return i.value == _this2.searchData.summary_flag;
      })) === null || _this$segmentSelectio2 === void 0 ? void 0 : _this$segmentSelectio2.label) || ''; // let data = [this.searchpkgs.find((i) => i.pkg_mark == this.DetailssearchData.pkg).pkg_name]

      var series = [];
      this.screenList.forEach(function (item, index) {
        series.push({
          name: item.label,
          type: "bar",
          yAxisIndex: _this2.collectNum.findIndex(function (i) {
            return i == item.prop;
          }) > -1 ? 1 : 0,
          data: currentChartData.map(function (i) {
            return i[item.prop];
          }),
          smooth: true,
          barMaxWidth: "50",
          symbol: "none"
        });
      });
      var option;
      option = {
        animationDuration: 3000,
        tooltip: {
          confine: true,
          trigger: "item",
          formatter: function formatter(params) {
            return "".concat(params.seriesName, ":").concat(params.value);
          }
        },
        legend: {
          width: "100%",
          icon: "circle",
          itemHeight: 12,
          bottom: "0%",
          itemWidth: 15,
          inactiveColor: "#666666",
          formatter: ["{a|{name}}"].join("\n"),
          textStyle: {
            fontSize: 12,
            lineHeight: 12,
            rich: {
              a: {
                width: 120,
                verticalAlign: "middle"
              }
            },
            padding: [0, 0, -2, -4] //[上、右、下、左]

          },
          selected: this.channelselected
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "18%",
          containLabel: true
        },
        toolbox: {
          z: 12,
          feature: {
            saveAsImage: {}
          }
        },
        xAxis: {
          type: "category",
          axisTick: {
            show: false
          },
          data: [this.$t('channelLabel') + currentLabel]
        },
        yAxis: [{
          type: "value",
          splitLine: {
            lineStyle: {
              type: "dashed"
            }
          },
          splitNumber: 5,
          axisLabel: {
            formatter: function formatter(value, index) {
              if (value >= 10000) {
                return (value / 10000).toFixed(2) + "万";
              } else if (value >= 1000) {
                return value;
              } else {
                return value;
              }
            }
          }
        }, {
          type: "value",
          splitNumber: 5,
          splitLine: {
            lineStyle: {
              type: "dashed"
            }
          }
        }],
        series: series
      };
      option && this.echartchannel.setOption(option, true);
      var that = this;
      this.echartchannel.on("legendselectchanged", function (params) {
        that.Detailsselected = JSON.parse(JSON.stringify(params.selected));
      });
    },
    exportdata: function exportdata() {
      var columns = [{
        label: this.$t('channelId'),
        prop: 'channel_mark'
      }, {
        label: this.$t('channelName'),
        prop: 'channel_name'
      }, {
        label: this.$t('time'),
        prop: 'hours'
      }];
      this.tableDataList.forEach(function (item) {
        columns.push({
          label: item.label,
          prop: item.prop
        });
      });
      var data = this.tableData;
      this.$export.excel({
        columns: columns,
        data: data,
        title: this.$t('channelYearQuarterMonthWeek')
      });
    }
    /**
     * 全天账号详情 end
     */

  }
};